<template>
  <div class="app pa-10 print-page" v-if="pageLoaded">
    <v-row class="justify-content-center">
      <v-col md="4" cols="12">
        <v-card class="common-card grey lighten-3 pa-10">
          <h4 class="c-purple font-weight-bold">ویرایش اجزای فاکتور</h4>
          <h5 class="c-grey my-8">موارد زیر در فاکتور نمایش داده می‌شود:</h5>
          <div class="switches ps-3">
            <v-switch
              v-model="instituteName"
              :class="instituteName ? 'switch-green' : 'switch-red'"
              label="نام موسسه"
            ></v-switch>
            <v-switch
              :class="customerInfo ? 'switch-green' : 'switch-red'"
              v-model="customerInfo"
              label="اطلاعات خریدار"
            ></v-switch>
            <v-switch
              v-if="invoiceType == 'preinvoice'"
              v-model="signature"
              label="تصویر مهر و امضا"
              :class="signature ? 'switch-green' : 'switch-red'"
            ></v-switch>
            <v-switch
              v-else
              v-model="paymentInfo"
              label="اطلاعات پرداخت"
              :class="paymentInfo ? 'switch-green' : 'switch-red'"
            ></v-switch>
            <v-switch
              v-if="invoiceType == 'invoice'"
              v-model="oldBalance"
              label="مانده از قبل"
              :class="oldBalance ? 'switch-green' : 'switch-red'"
            ></v-switch>
            <v-switch
              v-model="subDescription"
              label="نوشته‌ی زیر فاکتور"
              :class="subDescription ? 'switch-green' : 'switch-red'"
            ></v-switch>
          </div>
          <div class="py-8">
            <v-btn
              class="purple-mainBtn float-end pa-5"
              width="100"
              @click="submit()"
            >
              <span class="white--text">
                <v-icon class="me-1">mdi-printer</v-icon> چاپ
              </span>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- receipt -->
    <div id="Receipt" v-show="false">
      <table
        class="mainTable m-3 p-4 h-100 w-100"
        style="margin-top: 30px !important"
      >
        <thead v-if="instituteName">
          <tr>
            <td>
              <div style="text-align: center; width: 100%">
                <span style="font-size: 18px">فروشگاه پولاد پیچ کار</span>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="content" style="padding: 15px">
                <div>
                  <div>
                    <div
                      style="
                        border: 1px solid black;
                        border-radius: 15px;
                        padding: 10px; 
                      "
                    >
                      <h3 style="text-align: center">
                        {{
                          invoiceType == "invoice"
                            ? "فاکتور فروش"
                            : "پیش فاکتور"
                        }}
                        <span v-if="invoiceDetails.type == 'return'"
                          >(مرجوعی)</span
                        >
                        <span
                          v-else-if="
                            invoiceDetails.type != 'return' &&
                            printType == 'reprint'
                          "
                          >(چاپ مجدد)</span
                        >
                      </h3>
                      <div
                        style="display: flex !important; width: 100% !important"
                      >
                        <div
                          style="
                            font-size: 12px !important;
                            width: 50% !important;
                          "
                        >
                          <div v-if="customerInfo">
                            <span>خریدار: </span>
                            <span>
                              {{
                                invoiceDetails.shopCustomerName +
                                " (" +
                                invoiceDetails.shopCustomerCode +
                                ")"
                              }}
                            </span>
                            <br />
                            <div v-if="invoiceDetails.shopCustomerAddress">
                              <span>نشانی: </span>
                              <span>
                                {{ invoiceDetails.shopCustomerAddress }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            font-size: 12px;
                            width: 50% !important;
                            text-align: left !important;
                          "
                        >
                          <div>
                            <span>شماره: </span>
                            <span> {{ invoiceDetails.code }}</span>
                          </div>
                          <div>
                            <span>تاریخ: </span>
                            <span>
                              {{
                                moment(new Date()).format("jYYYY/jMM/jDD")
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-table
                  bordered
                  :fields="receiptFields"
                  :items="invoiceDetails.details"
                  small="small"
                  responsive
                  style="margin-top: 10px"
                >
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <span v-if="isPriceChanged(data)" class="me-1">*</span>
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(amount)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(totalPrice)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{
                        (
                          Number(data.item.amount) * data.item.price
                        ).toLocaleString()
                      }}
                    </div>
                  </template>
                </b-table>
                <div
                  style="
                    font-size: 13px;
                    margin-top: 8px !important;
                    margin-bottom: 8px !important;
                    padding-bottom: 5px !important;
                  "
                  :style="
                    paymentInfo || invoiceType == 'invoice'
                      ? 'border-bottom:1px solid black !important;'
                      : ''
                  "
                >
                  <div
                    style="
                      width: 100%;
                      display: flex !important;
                      font-size: 12px;
                    "
                  >
                    <div style="width: 50%">
                      <div v-if="invoiceType == 'invoice' && oldBalance">
                        <div>
                          مانده از قبل این فاکتور:
                          <span>
                            {{
                              returnBalance(invoiceDetails.oldInvoiceBalance)
                            }}
                          </span>
                        </div>
                        <div>
                          مانده با محاسبه فاکتور فعلی:
                          <span>
                            {{
                              returnBalance(
                                invoiceDetails.currentInvoiceBalance
                              )
                            }}
                          </span>
                        </div>
                        <div>
                          مانده نهایی:
                          <span>
                            {{
                              returnBalance(invoiceDetails.finalInvoiceBalance)
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="width: 25%; text-align: left; font-size: 12px">
                      <div>جمع کل:</div>
                      <div>تعداد:</div>
                      <div v-if="invoiceDetails.discount > 0">مالیات:</div>
                      <div v-if="invoiceDetails.discount > 0">تخفیف:</div>
                    </div>
                    <div
                      style="width: 2%; text-align: right; font-size: 12px"
                    ></div>
                    <div style="width: 23%; text-align: right; font-size: 12px">
                      <div>
                        <span v-if="!invoiceDetails.useCredit"
                          >{{
                            parseInt(
                              Number(
                                invoiceDetails.details
                                  .map(
                                    (x) => Number(x.price) * Number(x.amount)
                                  )
                                  .reduce((a, b) => a + b, 0)
                              )
                            ).toLocaleString()
                          }}
                          ریال
                        </span>
                      </div>
                      <div>
                        <span
                          >{{
                            invoiceDetails.details
                              .map((x) => Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                          }}
                        </span>
                      </div>
                      <div v-if="invoiceDetails.discount > 0">
                        <span>
                          {{
                            parseInt(
                              ((invoiceDetails.details
                                .map((x) => Number(x.price) * Number(x.amount))
                                .reduce((a, b) => a + b, 0) -
                                invoiceDetails.discount) *
                                invoiceDetails.vat) /
                                100
                            ).toLocaleString()
                          }}
                          ریال
                        </span>
                      </div>
                      <div v-if="invoiceDetails.discount > 0">
                        <span>
                          {{ invoiceDetails.discount.toLocaleString() }}
                          ریال
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div
                    style="
                      width: 100%;
                      display: flex !important;
                      font-size: 12px;
                    "
                  >
                    <div style="width: 70%">
                      مبلغ قابل پرداخت به حروف:

                      <span>
                        <numberToWords
                          :number="invoiceDetails.totalCost"
                          v-slot="{ words }"
                        >
                          <span class="me-10">
                            {{ words + " ریال " }}
                          </span></numberToWords
                        >
                      </span>
                    </div>
                    <div style="width: 30%; text-align: left">
                      مبلغ قابل پرداخت:

                      <span style="font-size: 12px">
                        {{ invoiceDetails.totalCost.toLocaleString() }}
                        ریال
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="invoiceType == 'invoice'"
                  style="
                    font-size: 12px;
                    margin-top: 8px !important;
                    margin-bottom: 8px !important;
                    padding-top: 5px !important;
                  "
                >
                  <div
                    style="width: 100%; display: flex !important"
                    v-if="invoiceDetails.type != 'return' && paymentInfo"
                  >
                    <div style="width: 50%">
                      <div>
                        نوع پرداخت:
                        <span>{{
                          invoiceDetails.type == "respite"
                            ? "امانی - پرداخت اعتباری"
                            : invoiceDetails.type == "definite"
                            ? "قطعی - پرداخت در لحظه"
                            : "-"
                        }}</span>
                      </div>
                      <div v-if="invoiceDetails.type == 'definite'">
                        نحوه پرداخت:
                        <span>
                          {{
                            paymentTypes.filter(
                              (x) =>
                                x.value == invoiceDetails.income.paymentType
                            )[0]
                              ? paymentTypes.filter(
                                  (x) =>
                                    x.value == invoiceDetails.income.paymentType
                                )[0].text
                              : "-"
                          }}
                        </span>
                      </div>
                    </div>
                    <!-- payment type details -->
                    <div
                      style="width: 50%"
                      v-if="
                        invoiceDetails.type == 'definite' &&
                        invoiceDetails.income.paymentType == 'cardTransfer'
                      "
                    >
                      <div>
                        شماره کارت فرستنده:
                        <span
                          dir="ltr"
                          lang="en"
                          style="direction: ltr; text-align: justify"
                          >{{
                            invoiceDetails.income.securedBuyerCardNumber
                          }}</span
                        >
                      </div>
                      <div>
                        شماره کارت گیرنده:
                        <span
                          dir="ltr"
                          lang="en"
                          style="direction: ltr; text-align: justify"
                          >{{
                            invoiceDetails.income.securedRecipientCardNumber
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                      style="width: 50%"
                      v-else-if="
                        invoiceDetails.type == 'definite' &&
                        invoiceDetails.income.paymentType == 'cheque'
                      "
                    >
                      <div>
                        شماره چک:
                        <span>{{ invoiceDetails.income.chequeNo }}</span>
                      </div>
                      <div>
                        شماره صیاد:
                        <span>{{
                          invoiceDetails.income.chequeSayyad
                            ? invoiceDetails.income.chequeSayyad
                            : "-"
                        }}</span>
                      </div>
                      <div>
                        تاریخ چک:
                        <span>{{ invoiceDetails.income.chequeDate }}</span>
                      </div>
                      <div>
                        وضعیت چک:
                        <span>
                          {{
                            chequeStatuses.filter(
                              (x) =>
                                x.value == invoiceDetails.income.chequeStatus
                            )[0]
                              ? chequeStatuses.filter(
                                  (x) =>
                                    x.value ==
                                    invoiceDetails.income.chequeStatus
                                )[0].text
                              : "-"
                          }}
                        </span>
                      </div>
                      <div>
                        نام بانک:
                        <span>{{ invoiceDetails.income.chequeBank }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="width: 100%; text-align: justify !important"
                    v-if="invoiceDetails.income.isPartial && paymentInfo"
                  >
                    پرداخت ثبت شده جزیی است
                    <span>
                      - مقدار پرداخت‌ جزئی:
                      {{
                        Number(
                          invoiceDetails.income.partialAmount
                        ).toLocaleString() + " ریال "
                      }}
                    </span>
                  </div>
                  <div
                    style="width: 100%; text-align: justify !important"
                    v-if="invoiceDetails.income.description"
                  >
                    توضیحات:
                    <span>{{ invoiceDetails.income.description }}</span>
                  </div>
                </div>
                <div
                  v-else-if="invoiceType == 'preinvoice'"
                  style="
                    height: 100px !important;
                    font-size: 12px;
                    padding-top: 5px !important;
                  "
                >
                  <div style="width: 100%; display: flex !important">
                    <div style="width: 50%">
                      توضیحات:
                      <span>
                        {{ invoiceDetails.description }}
                      </span>
                    </div>
                    <div style="width: 50%" v-if="signature">
                      مهر و امضاء مدیر فروش:
                    </div>
                  </div>
                </div>
                <div
                  class="bot-box"
                  style="clear: both; font-size: 12px"
                  v-if="subDescription && invoiceDetails.subInvoiceLine"
                >
                  <div>
                    <span>
                      {{ invoiceDetails.subInvoiceLine }}
                    </span>
                  </div>
                </div>
                <!-- <div class="barcode-box">
                    <barcode
                      :value="receiptNumber"
                      displayValue="false"
                      style="transform: translateX(50px)"
                    >
                    </barcode>
                  </div> -->
                <!-- <div class="bot-box">
                    <div>از اینکه فروشگاه مارو انتخاب کردی خیلی ممنونیم (:</div>
                    <div>اینستاگرام: ace_pet_club</div>
                    <div>شماره تماس: 09124061268</div>
                    <div>
                      بلوار اندرزگو - بلوار صبا - کوچه کیارنک - نبش کوچه مقدم
                    </div>
                    <div class="border-top">
                      پت کلاب اس همه روزه از ساعت ۱۱ صبح الی ۸ شب منتظر شماست!
                    </div>
                  </div> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- receipt -->
    <v-dialog width="500" persistent v-model="getReceiptDialog">
      <v-card class="pa-8 shop-dialog">
        <div class="d-flex justify-content-center">
          <v-icon class="green--text me-2">mdi-check-decagram</v-icon>
          <h5 style="font-size: 17px" class="c-grey pt-2">فاکتور چاپ شد.</h5>
        </div>
        <div class="d-flex justify-space-around mt-5">
          <v-btn @click="printAgain()" class="purple-mainBtn" width="160"
            ><v-icon class="me-1">mdi-printer</v-icon>چاپ مجدد</v-btn
          >
          <v-btn @click="finish()" class="purple-borderedBtn" width="160"
            ><v-icon class="me-1">mdi-checkbox-marked-outline</v-icon
            >اتمام</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import { numberToWords } from "@persian-tools/vue-persian-tools/dist/modules";
export default {
  components: { numberToWords },
  data() {
    return {
      moment: moment,
      isLoading: false,
      instituteName: true,
      instituteLogo: true,
      nationalCode: true,
      subDescription: true,
      signature: true,
      invoiceNumber: true,
      oldBalance: true,
      customerInfo: true,
      paymentInfo: true,
      getReceiptDialog: false,
      customerMobile: null,
      shopCustomerName: null,
      invoiceType: this.$route.params.invoiceType,
      printType: this.$route.params.type,
      invoiceDetails: {
        invoiceId: "",
        shopCustomerName: "",
        amount: null,
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: "",
        paymentType: "",
        vat: 0,
        discount: 0,
        useCredit: false,
        totalCost: 0,
        startDate: null,
        type: "",
        chequeNo: 0,
        chequeDate: "",
        details: [],
        invoiceCode: 0,
      },
      receiptFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد کالا" },
        { key: "name", label: "شرح کالا" },
        { key: "amount", label: "تعداد" },
        { key: "price", label: "قیمت واحد" },
        { key: "totalPrice", label: "جمع" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      oldCustomerBalance: "",
      pageLoaded: false,
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      prevRoute: null,
    };
  },
  methods: {
    isPriceChanged(data) {
      if (data.item.manualPrice) {
        return true;
      } else {
        return false;
      }
    },
    getData() {
      this.isLoading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + this.$route.params.id,
        // {
        //   shopInvoiceId: this.$route.params.id,
        // },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoiceDetails = res.data;
            //this.getBalance(res.data.shopCustomerId);
            this.customerMobile = res.data.shopCustomerMobile;
            this.shopCustomerName = res.data.shopCustomerName;
            this.isLoading = false;
            setTimeout(() => {
              this.pageLoaded = true;
            }, 300);
          } else {
            this.toast(res.data, "error");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response, "error");
          this.isLoading = false;
        });
    },
    returnBalance(value) {
      if (value > 0) {
        value = value.toLocaleString() + " ریال بدهکار";
      } else if (value < 0) {
        value = Math.abs(value).toLocaleString() + " ریال بستانکار";
      } else {
        value = "تسویه";
      }
      return value;
    },
    //getBalance(customerId) {
    //  this.gettingBalance = true;
    //  Axios.post(
    //    this.baseUrl + "/ppkpms/shop/payments/customerBalance",
    //    {
    //      shopCustomerId: customerId,
    //    },
    //    {
    //      headers: {
    //        Authorization: "Bearer: " + localStorage.getItem("token"),
    //      },
    //    }
    //  )
    //    .then((res) => {
    //      if (res.status == 200) {
    //        this.allShopIncomeBalance = res.data.allShopIncomeBalance;
    //        this.invoiceDetails.customerBalance = res.data.balanceData;
    //        if (this.invoiceDetails.customerBalance > 0) {
    //          this.invoiceDetails.customerBalance =
    //            this.invoiceDetails.customerBalance.toLocaleString() +
    //            " ریال بدهکار";
    //        } else if (this.invoiceDetails.customerBalance < 0) {
    //          this.invoiceDetails.customerBalance =
    //            Math.abs(this.invoiceDetails.customerBalance).toLocaleString() +
    //            " ریال بستانکار";
    //        } else {
    //          this.invoiceDetails.customerBalance = "تسویه";
    //        }

    //        setTimeout(() => {
    //          this.gettingBalance = false;
    //        }, 500);
    //      } else {
    //        const title = (
    //          <div>
    //            <h5>خطا </h5>
    //            <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
    //          </div>
    //        );
    //        this.toast(title, "error");
    //      }
    //    })
    //    .catch((err) => {
    //      console.log(err);
    //      this.toast(err.response.data, "error");
    //    });
    //},
    submit() {
      this.getReceiptDialog = true;
      this.printReceipt();
    },
    printAgain() {
      this.printType = "reprint";
      setTimeout(() => {
        this.printReceipt();
      }, 100);
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/customreceipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    finish() {
      this.prevRoute
        ? this.prevRoute.path != "/"
          ? this.$router.push(this.prevRoute)
          : this.invoiceType == "preinvoice"
          ? this.$router.push("/shop/proformaList")
          : this.$router.push("/shop/salesinvoices")
        : this.$router.push("/shop/salesinvoices");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    //if (localStorage.getItem("oldCustomerBalance")) {
    //  this.oldCustomerBalance = localStorage.getItem("oldCustomerBalance");
    //  localStorage.removeItem("oldCustomerBalance");
    //}
    this.getData();
  },
};
</script>

<style lang="scss">
@media print {
  @page {
    size: landscape;
    font-size: 30%;
    text-color: blue;
  }
}
.print-page {
  .switch-red {
    .v-input--switch__thumb {
      color: #ef5350 !important;
    }
    .v-input--switch__track {
      color: #ef5350 !important;
    }
  }
  .switch-green {
    .v-input--switch__thumb {
      color: #26a69a !important;
    }
    .v-input--switch__track {
      color: #26a69a !important;
    }
  }
  .v-label {
    right: 5px !important;
  }
}
</style>
